import { Mail, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-brown-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">BNC Africa Holdings</h3>
            <p className="text-gray-300">Building businesses that drives growth and transform lives.</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Info</h3>
            <div className="space-y-2">
              <p className="flex items-center gap-2">
                <MapPin size={18} />
                Accra, Ghana
              </p>
              <p className="flex items-center gap-2">
                <Phone size={18} />
                <span className="flex flex-col">
                  <span>024 314 9817</span>
                  <span>024 306 5135</span>
                </span>
              </p>
              <p className="flex items-center gap-2">
                <Mail size={18} />
                info@bncafricaholdings.com
              </p>
            </div>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-brown-300">Home</a></li>
              <li><a href="/about" className="hover:text-brown-300">About Us</a></li>
              <li><a href="/contact" className="hover:text-brown-300">Contact</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-brown-700 text-center">
          <p>&copy; {new Date().getFullYear()} BNC Africa Holdings Group Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}